var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('doughnut-chart',{attrs:{"percent":_vm.percent,"visible-value":true,"custom-text":_vm.value + ' %',"title":_vm.title,"stroke-width":_vm.hollowSize,"width":_vm.radius,"height":_vm.radius}})}
var staticRenderFns = []

export { render, staticRenderFns }